<template>
  <div :class="onlyFooter ? 'only-footer-wrapper' : ''">
    <template v-if="onlyFooter">
      <FooterApp :remoteFooterUrl="remoteFooterUrl" class="only-footer-component" />
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import FooterApp from './components/footer/footer.vue';

export default {
  name: 'App',
  components: { FooterApp },
  data(){
    return {
      onlyFooter: false,
      remoteFooterUrl: process.env.VUE_APP_REMOTE_FOOTER_URL || 'https://powergiobsrl.it/'
    };
  },
  methods: {
    ...mapActions('auth', ['checkAuth'])
  },
  created() {
    this.checkAuth();
    // Attiva modalità solo footer se variabile ambiente impostata
    this.onlyFooter = (process.env.VUE_APP_SHOW_ONLY_FOOTER === '1' || window?.location?.search?.includes('onlyFooter=1'));
  }
  
}
</script>

<style>
.only-footer-wrapper, .only-footer-wrapper body, .only-footer-wrapper html { height:100%; }
.only-footer-wrapper { min-height:100vh; display:flex; flex-direction:column; }
.only-footer-component { flex:1 1 auto; display:flex; }
.only-footer-component > footer { width:100%; }
html.only-footer, body.only-footer { overflow:hidden; }
</style>
